/** Strip Asana `<body>` wrapper and normalize newlines for display/edit. */
export function stripAsanaBody(html: string) {
  return String(html || '')
    .replace(/<\/?body[^>]*>/gi, '')
    .replace(/\r\n|\r|\n/g, '<br />')
}

/** Pull description HTML from ticket details (prefer html_notes). */
export function descriptionHtmlFromDetails(details?: { html_notes?: string; notes?: string } | null) {
  if (!details) return ''
  if (details.html_notes) return stripAsanaBody(String(details.html_notes))
  return details.notes || ''
}

/**
 * Remove the portal "Submitted By:" attribution so the editor only shows the
 * user-authored body. Reattached on save by the backend.
 */
export function stripSubmittedByAttribution(htmlOrText: string) {
  let out = stripAsanaBody(htmlOrText)
  out = out.replace(/^<strong>\s*Submitted By:[^<]*<\/strong>\s*(?:<br\s*\/?>|\n)*/i, '')
  out = out.replace(/^Submitted By:[^\n<]*(?:\n|<br\s*\/?>)*/i, '')
  return out.trim()
}

export function commentDisplayHtml(msg: { html_text?: string; text?: string }) {
  if (msg.html_text) return stripAsanaBody(msg.html_text)
  return msg.text || ''
}

const IMAGE_EXT = /\.(png|jpe?g|gif|webp|bmp|svg)$/i

export function isImageFileName(name?: string | null) {
  return !!name && IMAGE_EXT.test(name)
}
